import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&',
        competence: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'user.Add skill' | translate }}</h2>
        </div>
        <form ng-submit="vm.save()" class="form">
            <div class="modal-body">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.skills[0].skillId">
                        <label class="label">{{ 'user.Skill name' | translate }} *</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.form.model.skills[0].skillId">
                                <option value=""></option>
                                <option value="{{ item.id }}" ng-repeat-start="item in vm.skills">
                                   {{ item.name }}
                                </option>
                                <option value="{{ l2item.id }}" ng-repeat-start="l2item in item.children">
                                    &nbsp;&nbsp;{{ l2item.name }}
                                </option>
                                <option value="{{ l3item.id }}" ng-repeat-start="l3item in l2item.children">
                                    &nbsp;&nbsp;&nbsp;{{ l3item.name }}
                                </option>
                                <option value="{{ l4item.id }}" ng-repeat-start="l4item in l3item.children">
                                   &nbsp;&nbsp;&nbsp;&nbsp;{{ l4item.name }}
                                </option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                            </select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.skills[0].type">
                        <span class="label">{{ 'user.Skill type' | translate }}</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label><input
                                     ng-model="vm.form.model.skills[0].type"
                                     type="radio"
                                     value="{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.KEYS.MANDATORY }}"> {{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS.MANDATORY }}
                                      </label>
                                    <label><input
                                         ng-model="vm.form.model.skills[0].type"
                                         type="radio"
                                         value="{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.KEYS.OPTIONAL }}"> {{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS.OPTIONAL }}</label>
                                </li>
                                <form-row-error></form-row-error>
                            </ul>
                        </div>
                    </form-row>
                </form-wrapper>
            </div>
            <div class="modal-footer" >
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                        </li>
                    </ul>
                </div>
        </form>
    `
})
export default class {
    constructor (FormFactory, SkillResource, USER_COMPETENCE_SKILL_TYPE_ENUM) {
        this.FormFactory = FormFactory;
        this.SkillResource = SkillResource;
        this.USER_COMPETENCE_SKILL_TYPE_ENUM = USER_COMPETENCE_SKILL_TYPE_ENUM;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.competence);
        this.SkillResource.tree().$promise.then((skills) => {
            this.skills = skills;
        });
    }

    save () {
        return this.form.save().then((competence) => {
            return this.onUpdate({ updatedCompetence: competence });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/competence/addSkill/index.js